import CaseStudyContext from '@App/pages/CaseStudy/CaseStudyContext/CaseStudyContext';

import { LOCATIONS } from './context.constants';

function Context() {
  return (
    <CaseStudyContext
      locations={LOCATIONS}
      sectionClassName="pagasitikos-gulf-context"
      mapZoom={9}
      fitToMarkers={false}
    />
  );
}

export default Context;
